import React, { useContext, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import FloatingLabel from "react-bootstrap/FloatingLabel";

import Form from "react-bootstrap/Form";

import Utils from "../../../Utils";
import ContextComponent from "../../../AppContext";
import FolderTree from "../sites/FolderTree";

const EditUserPage = ({ props }) => {

  let { setAlert, setLoadingState, setCanRedirectToLogin } = useContext(ContextComponent);
  let tableData = props?.tableData || [];

  let editableUser = props?.editableUser || {};
  let editableUserIndex = props?.editableUserIndex || {};

  let setTableData = props?.setTableData || (() => { });
  let ROLES = Utils.ROLES || {};
  let [firstName, setFirstName] = useState(editableUser.firstname || "");
  let [lastName, setLastName] = useState(editableUser.lastname || "");
  let [email, setEmail] = useState(editableUser.email || "");
  let [password, setPassword] = useState(editableUser.password || "");
  let roleValue = (editableUser?.roles?.length ? editableUser?.roles[0] : "") || "";
  let [role, setRole] = useState(editableUser?.roles);
  let [admin, setAdmin] = useState(editableUser.admin ?? false);
  let [picture, setPicture] = useState(editableUser.picture || "");
  let siteValue = (editableUser?.sites?.length ? editableUser?.sites[0] : "") || "";
  let [site, setSite] = useState(editableUser?.sites);
    let [selectedFolderId, setSelectedFolderId] = useState(
      editableUser.projects ? [...editableUser.projects] : []
    );
    let [expandedFolders, setExpandedFolders] = useState(
      editableUser.projects?.[0] ? [editableUser.projects[0]] : []
    );

  const hideModal = (e) => {
    props.setEditModalCanOpen(false);
  };

  function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  const saveUser = async (e) => {
    setLoadingState({
      applyMask: true,
      text: "Updating user",
    });

    // Wait for 5 seconds
    await delay(5000);

    const success = (res) => {
      hideModal();
      setLoadingState({
        applyMask: false,
      });
      setAlert({
        show: true,
        message: res?.data?.message
          ? res.data.message
          : "User updated successfully!",
        type: "success",
      });
      props.loadAllUsers();
    };
    const fail = (err) => {
      setLoadingState({
        applyMask: false,
      });
      if (err?.redirect) {
        setCanRedirectToLogin(true);
      }
      setAlert({
        show: true,
        message: err?.data?.message
          ? err.data.message
          : "User edit failed",
        type: "danger",
      });
      console.log(err);
    };

    let formData = {
      firstName,
      lastName,
      email,
      password,
      roles: role,
      admin,
      sites: site,
      projects: selectedFolderId
    };
    try {
      // console.log(editableUser.id);
      Utils.editUser(formData, editableUser.id).then(success, fail);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (editableUser.projects) {
      setSelectedFolderId([...editableUser.projects]);
    }
  }, [editableUser.projects]);

  const toggleFolder = (folderId) => {
    setExpandedFolders(prev => {
      if (prev.includes(folderId)) {
        return prev.filter(id => id !== folderId);
      }
      return [...prev, folderId];
    });
  };

  const firstNameHandler = (e) => {
    let value = e?.currentTarget?.value || "";
    setFirstName(value);
  };

  const lastNameHandler = (e) => {
    let value = e?.currentTarget?.value || "";
    setLastName(value);
  };

  const rolesHandler = (e) => {
    let value = [].slice.call(e.target.selectedOptions).map(item => item.value) || [];
    setRole(value);
  }

  const emailHandler = (e) => {
    let value = e?.currentTarget?.value || "";
    setEmail(value);
  };

  const passwordHandler = (e) => {
    let value = e?.currentTarget?.value || "";
    setPassword(value);
  };

  const adminHandler = (e) => {
    let value = e?.currentTarget?.checked || "";
    setAdmin(value);
  };

  useEffect(() => { }, [props.editModalCanOpen]);

  const handleClose = (e) => {
    props.setEditModalCanOpen(false);
  };

  // const siteHandler = (e) => {
  //   let value = [].slice.call(e.target.selectedOptions).map(item => item.value) || [];
  //   setSite(value);
  // }

  const siteHandler = (e) => {
    // Extracting the name and checked properties from the event target
    const { name, checked } = e.target;
    console.log(e.target);

    // If the checkbox is checked, add its name to the selectedItems array
    // If it's unchecked, remove its name from the selectedItems array
    if (checked) {
      setSite([...site, name]);
    } else {
      setSite(site.filter(item => item !== name));
    }
  };

  let [sitesDataAvailable, setSitesDataAvailable] = useState(false);
  let [sites, setSites] = useState([]);

  const sitesFetchSuccess = (res) => {
    setLoadingState({
      applyMask: false,
    });
    //console.log(res);
    setSites(res.data);
    setSitesDataAvailable(true);
  };
  const sitesFetchFail = (err) => {
    setLoadingState({
      applyMask: false,
    });
    err?.message?.length && console.log(err);
    // setErrorMessage(error);
    if (err?.redirect) {
      setCanRedirectToLogin(true);
    }
  };

  useEffect(() => {
    setLoadingState({
      applyMask: true,
    });
    Utils.getAllSites().then(sitesFetchSuccess, sitesFetchFail);
  }, []);

  return (
    <>
      {
        <Modal centered show={props.editModalCanOpen} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Edit user</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="indi-add-form-wrapper d-flex flex-column">
                <div className="indi-add-form-item d-flex flex-column">
                  <div className="indi-add-form-item-input row">
                    <FloatingLabel label="First name">
                      <Form.Control
                        type="text"
                        className="indi-input-field"
                        id="firstName"
                        placeholder="Enter first name"
                        autoComplete="off"
                        defaultValue={firstName}
                        onChange={firstNameHandler}
                      />
                    </FloatingLabel>
                  </div>
                </div>

                <div className="indi-add-form-item d-flex flex-column">
                  <div className="indi-add-form-item-input row">
                    <FloatingLabel label="Last name">
                      <Form.Control
                        type="text"
                        className="indi-input-field"
                        id="lastName"
                        defaultValue={lastName}
                        placeholder="Enter last name"
                        autoComplete="off"
                        onChange={lastNameHandler}
                      />
                    </FloatingLabel>
                  </div>
                </div>

                <div className="indi-add-form-item d-flex flex-column">
                  <div className="indi-add-form-item-input row">
                    <FloatingLabel label="E-mail">
                      <Form.Control
                        type="text"
                        className="indi-input-field"
                        id="email"
                        defaultValue={email}
                        placeholder="Enter email"
                        autoComplete="off"
                        onChange={emailHandler}
                      />
                    </FloatingLabel>
                  </div>
                </div>


                <div className="indi-add-form-item d-flex flex-column">
                  <div className="indi-add-form-item-input row">
                    <FloatingLabel label="Change password">
                      <Form.Control
                        type="password"
                        className="indi-input-field"
                        id="password"
                        placeholder="Enter initial password"
                        autoComplete="off"
                        onChange={passwordHandler}
                      />
                    </FloatingLabel>
                  </div>
                </div>

                <div className="indi-add-form-item d-flex flex-column">
                  <div className="indi-add-form-item-input row">
                    {ROLES && (
                      <FloatingLabel label="Role">
                        <Form.Select
                          multiple
                          defaultValue={role || ROLES[0].name}
                          id="brand"
                          size="sm"
                          className="indi-input-field indi-input-select-field indi-multi-input-select-field"
                          onChange={rolesHandler}
                        >
                          {ROLES?.map((rol, index) => (
                            <option value={rol.value} key={index}>
                              {rol.name}
                            </option>
                          ))}
                        </Form.Select>
                      </FloatingLabel>
                    )}
                  </div>
                </div>

                {/* <div className="indi-add-form-item d-flex flex-column">
                  <div className="indi-add-form-item-input row">
                    {sitesDataAvailable && (
                      <div className="d-flex indi-input-field indi-multi-input-cb-field">
                        <div className="">Sites:</div>
                        <div className="">
                          {sites.map((item, index) => (
                            <Form.Check
                              key={`checkbox-${index}`}
                              inline
                              label={item.name}
                              name={item.name}
                              type="checkbox"
                              id={`checkbox-${index}`}
                              onChange={siteHandler}
                              defaultChecked={site.includes(item.name)}
                            />
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div> */}

                 <div className="indi-add-form-item d-flex flex-column mt-3">
                    <div className="indi-add-form-item-input row">
                      <div className="d-flex flex-column w-100">
                        <label className="mb-2 fw-bold">Select Folder:</label>
                          <FolderTree
                          selectionMode="multiple"
                          selectedFolderId={selectedFolderId}
                          setSelectedFolderId={setSelectedFolderId}
                          currentFolderId={null} 
                          expandedFolders={expandedFolders}
                          toggleFolder={toggleFolder}
                          />
                      </div>
                    </div>
                  </div>

                <div className="indi-add-form-item d-flex">
                  <div className="indi-add-form-item-input">
                    <Form.Check
                      type="switch"
                      className="indi-input-switch-field indi-input-field"
                      id="admin"
                      defaultChecked={admin}
                      label="is admin?"
                      onChange={adminHandler}
                    />
                  </div>
                </div>
              </div>

              <div className="indi-add-footer">
                <div className="indi-add-page-footer-btn-wrapper float-right">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={hideModal}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={saveUser}
                  >
                    Save
                  </button>
                </div>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      }
    </>
  );
};

export default EditUserPage;
